import fetch from '../utils/fetch';

// 基础数据获取接口

// 获取全部基础数据
export function getAll() {
    return fetch({
        method: 'GET',
        url: 'basics/all',
    })
}

// 获取权限下的项目
export function getProjects() {
    return fetch({
        method: 'GET',
        url: 'basics/projects',
    })
}

// 获取权限下的区域
export function getAreas() {
    return fetch({
        method: 'GET',
        url: 'basics/areas',
    })
}

// 获取全部项目
export function getAllProjects() {
    return fetch({
        method: 'GET',
        url: 'projectBasics/allProjects',
    })
}

// 获取房间状态
export function getRoomstatus(){
    return fetch({
        method: 'GET',
        url: 'basics/roomstatus',
    })
}

// 获取表类型
export function getWaterwatt(){
    return fetch({
        method: 'GET',
        url: 'basics/waterwatt',
    })
}

//根据员工编号查询员工信息
export  function getEmployeeByCode(params) {
  return fetch({
    method:'GET',
    url:'employee/getEmployeeByCode',
    params
  })

}

// 获取项目下所有的ZO
export function getProjectZos(projectFid) {
    return fetch({
        method: 'GET',
        url: 'basics/getProjectZos',
        params:{
            projectFid
        }
    })
}

export function getProjectZosByCityCodeOrProjectFid(params) {
  return fetch({
    method: 'POST',
    url: '/basics/getProjectZosByCityCodeOrProjectFid',
   data:params
  })
}

// 获取项目下所有的房型
export function getProjectHouseType(projectFid) {
    return fetch({
        method: 'GET',
        url: 'basics/getProjectHouseType',
        params:{
            projectFid
        }
    })
}

//城市项目
export function allCityProjects() {
  return fetch({
    method: 'GET',
    url: 'projectBasics/allCityProjects',
  })
}

// 用户权限城市列表、品牌枚举、合作模式枚举条件查询

export function getProjectCondition() {
    return fetch({
        method: 'GET',
        url: 'projectBasics/getProjectCondition',
    })
}

//   根据城市 品牌 合作模式 筛选出项目
export function projectsByCondition(params) {
    return fetch({
        method: 'POST',
        url: '/project/projectsByCondition',
        data:params
    })
}

export function getOrganList(params) {
    return fetch({
        method: 'POST',
        url: '/project/getOrganList',
        data:params
    })
}

export function getUserList(params) {
    return fetch({
        method: 'POST',
        url: '/project/getUserList',
        data:params
    })
}
